// extracted by mini-css-extract-plugin
module.exports = {"fleche-right":"icon_fleche-right__3KawP","fleche-up":"icon_fleche-up__l0jjO","fleche-down":"icon_fleche-down__DF_Dn"};